import storage from 'redux-persist/lib/storage';

export const userSettingsPersistConfig = {
  key: 'userSettings',
  storage,
};
